<!--  -->
<template>
  <div class="cen">
    <dl class="navigation">
      <div class="dddiv">
        <div class="dd">1<span>户籍信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd li_special">2<span>户籍附件</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">3<span>房产信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">4<span>学校信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">5<span>提交信息</span></div>
      </div>
    </dl>
    <van-form @submit="next" @failed="onFailed" ref="forms">
      <!-- 监护人(一)正反面身份证 -->
      <van-field
        required
        name="uploader"
        label="监护人(一)正反面身份证"
        :rules="rules.upimg1"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList1"
            name="1"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
          <van-uploader
            v-model="imgstaus.fileList2"
            name="2"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
          <div class="tupian">
            <div>
              <img src="../assets/images/888.png" alt="" />
              <span>国徽面范例图</span>
            </div>
            <div>
              <img src="../assets/images/777.png" alt="" />
              <span>人像面范例图</span>
            </div>
          </div>
        </template>
      </van-field>
      <!-- 监护人(二)正反面身份证 -->
      <van-field name="uploader" label="监护人(二)正反面身份证">
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList3"
            name="3"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
          <van-uploader
            v-model="imgstaus.fileList4"
            name="4"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 父亲户口页 -->
      <van-field
        required
        name="uploader"
        label="父亲户口页"
        v-if="ruleForm1.yuanyinid == '0' || ruleForm1.yuanyinid == '1'"
        :rules="rules.upimg16"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList16"
            name="16"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 母亲户口页-->
      <van-field
        required
        name="uploader"
        label="母亲户口页"
        v-if="ruleForm1.yuanyinid == '0' || ruleForm1.yuanyinid == '2'"
        :rules="rules.upimg17"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList17"
            name="17"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- （外）祖父母户口页-->
      <van-field
        required
        name="uploader"
        label="（外）祖父母户口页"
        v-if="ruleForm1.yuanyinid == '4'"
        :rules="rules.upimg18"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList18"
            name="18"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 其他证明-->
      <van-field
        required
        name="uploader"
        label="其他证明"
        v-if="ruleForm1.yuanyinid == '5'"
        :rules="rules.upimg19"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList19"
            name="19"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 学生所在户口本首页-->
      <van-field
        required
        name="uploader"
        label="学生所在户口本首页"
        :rules="rules.upimg20"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList20"
            name="20"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 户主页-->
      <van-field required name="uploader" label="户主页" :rules="rules.upimg6">
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList6"
            name="6"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 学生户口页-->
      <van-field
        required
        name="uploader"
        label="学生户口页"
        :rules="rules.upimg9"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList9"
            name="9"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 出生证明-->
      <van-field name="uploader" label="出生证明" :rules="rules.upimg10">
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList10"
            name="10"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 居住证照片-->
      <van-field
        required
        name="uploader"
        label="居住证照片"
        :rules="rules.upimg11"
        v-if="ruleForm1.isjzz == '0'"
      >
        <template #input>
          <van-uploader
            v-model="imgstaus.fileList11"
            name="11"
            :max-count="1"
            @delete="delimg"
            :after-read="upimg"
          />
        </template>
      </van-field>
      <!-- 提交按钮 -->
      <div style="margin: 0.64rem">
        <van-button class="btn" native-type="button" @click="back"
          >返回</van-button
        >
        <van-button class="btn" :loading="loading" native-type="submit"
          >保存并下一步</van-button
        >
      </div>
      <div class="bgdiv"></div>
    </van-form>
    <notices></notices>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "element-ui/lib/theme-chalk/index.css";
import { upimg, savetwo, selecttwo, selectone } from "@/api/news";
import { mapGetters } from "vuex";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    // 自定义验证
    let validateImage = (rule, value, callback) => {
      //验证器
      if (!this.ruleForm2.upimg2) {
        //为true代表图片在  false报错
        return false;
      } else {
        return true;
      }
    };
    // 自定义验证
    let validimg = (rule, value, callback) => {
      //验证器
      console.log(rule, value);
      if (rule[0].status == "failed" || rule[0].status == "uploading") {
        //为true代表图片在  false报错
        return false;
      } else {
        return true;
      }
    };
    return {
      firstget: "0",
      codeDisabled: false,
      loading: false,
      cha1: 0,
      cha2: 0,
      fileUpload: "#",
      typeId: "",
      backId: "",
      ruleForm1: {}, //判断显示附件的对象
      imgstaus: {
        upimg1: false, //监护人1正面
        upimg2: false, //监护人1反面
        upimg3: false, //监护人2正面
        upimg4: false, //监护人2反面
        upimg5: false, //结婚证
        upimg6: false, //户主页
        upimg7: false, //离婚证 x
        upimg8: false, //离婚协议 x
        upimg9: false, //学生户口页
        upimg10: false, //出生证明
        upimg11: false, //居住证照片
        upimg12: false, //特殊优抚 其他 证明信 x
        upimg13: false, //拆迁证明 x
        upimg14: false, //特殊优抚 哥哥或姐姐出生证明 x
        upimg15: false, //监护人户口页 x
        upimg16: false, //父亲户口页
        upimg17: false, //母亲户口页
        upimg18: false, //（外）祖父母户口页
        upimg19: false, //其他证明
        upimg20: false, //学生所在户口本首页
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList4: [],
        fileList5: [],
        fileList6: [],
        fileList7: [],
        fileList8: [],
        fileList9: [],
        fileList10: [],
        fileList11: [],
        fileList12: [],
        fileList13: [],
        fileList14: [],
        fileList15: [],
        fileList16: [],
        fileList17: [],
        fileList18: [],
        fileList19: [],
        fileList20: [],
      },
      fileList: [],
      ruleForm2: {
        id: "",
        upimg1: "", //监护人1正面
        upimg2: "", //监护人1反面
        upimg3: "", //监护人2正面
        upimg4: "", //监护人2反面
        upimg5: "", //结婚证
        upimg6: "", //户主页
        upimg7: "", //离婚证 x
        upimg8: "", //离婚协议 x
        upimg9: "", //学生户口页
        upimg10: "", //出生证明
        upimg11: "", //居住证照片
        upimg12: "", //特殊优抚 其他 证明信 x
        upimg13: "", //拆迁证明 x
        upimg14: "", //特殊优抚 哥哥或姐姐出生证明 x
        upimg15: "", //监护人户口页 x
        upimg16: "", //父亲户口页
        upimg17: "", //母亲户口页
        upimg18: "", //（外）祖父母户口页
        upimg19: "", //其他证明
        upimg20: "", //学生所在户口本首页
      },
      rules: {
        upimg1: [
          {
            required: true,
            validator: validimg,
            message: "请上传监护人(一)正面证件",
            trigger: "blur",
          },
          {
            required: true,
            validator: validateImage,
            message: "请上传监护人(一)反面证件",
            trigger: "blur",
          },
        ],
        upimg2: [
          {
            required: true,
            validator: validimg,
            message: "请上传监护人(一)反面证件",
            trigger: "blur",
          },
        ],
        upimg5: [
          {
            required: true,
            validator: validimg,
            message: "请上传结婚证",
            trigger: "blur",
          },
        ],
        upimg6: [
          {
            required: true,
            validator: validimg,
            message: "请上传户主页",
            trigger: "blur",
          },
        ],
        upimg7: [
          {
            required: true,
            validator: validimg,
            message: "请上传离婚证",
            trigger: "blur",
          },
        ],
        upimg8: [
          {
            required: true,
            validator: validimg,
            message: "请上传离婚协议",
            trigger: "blur",
          },
        ],
        upimg9: [
          {
            required: true,
            validator: validimg,
            message: "请上传学生户口页",
            trigger: "blur",
          },
        ],
        // upimg10: [
        //   { required: true, message: "请上传学生出生证明", trigger: "blur" },
        // ],
        upimg11: [
          {
            required: true,
            validator: validimg,
            message: "请上传居住证",
            trigger: "change",
          },
        ],
        upimg12: [
          {
            required: true,
            validator: validimg,
            message: "请上传特殊优抚证明信",
            trigger: "blur",
          },
        ],
        upimg13: [
          {
            required: true,
            validator: validimg,
            message: "请上传拆迁证明",
            trigger: "blur",
          },
        ],
        upimg14: [
          {
            required: true,
            validator: validimg,
            message: "请上传哥哥/姐姐出生证明",
            trigger: "blur",
          },
        ],
        upimg15: [
          {
            required: true,
            validator: validimg,
            message: "请上传监护人户口页",
            trigger: "blur",
          },
        ],
        upimg16: [
          {
            required: true,
            message: "请上传父亲户口页",
            validator: validimg,
            trigger: "blur",
          },
        ],
        upimg17: [
          {
            required: true,
            validator: validimg,
            message: "请上传母亲户口页",
            trigger: "blur",
          },
        ],
        upimg18: [
          {
            required: true,
            validator: validimg,
            message: "请上传（外）祖父母户口页",
            trigger: "blur",
          },
        ],
        upimg19: [
          {
            required: true,
            validator: validimg,
            message: "请上传其他证明",
            trigger: "blur",
          },
        ],
        upimg20: [
          {
            required: true,
            validator: validimg,
            message: "请上传学生所在户口本首页",
            trigger: "blur",
          },
        ],
      },
      tjpan: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      hideUploadEdit: false,
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["leftBtnClick", "rightBtnClick"]),
  },
  //监控data中的数据变化
  watch: {
    leftBtnClick(clickdic) {
      console.log(clickdic);
      this.$router.push({
        path: "/p-register",
      });
    },
    rightBtnClick(clickdic) {
      // console.log(clickdic);
      sessionStorage.setItem("from", JSON.stringify(this.from));
      this.$router.push({
        path: "/record",
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loading = true;
    this.pan();
    this.setsession();
  },
  methods: {
    onFailed(failed) {
      console.log(failed);
      const errors = failed.errors;
      this.$refs.forms.scrollToField(errors[0].name, false);
    },
    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //判断显示那些附件
    pan() {
      if (JSON.parse(sessionStorage.getItem("from1"))) {
        this.ruleForm1 = JSON.parse(sessionStorage.getItem("from1"));
        this.cha1 = 1;
        if (this.cha1 == "1" && this.cha2 == "1") {
          this.loading = false;
        }
      } else {
        this.selectone();
      }
    },
    //读取本地存储
    setsession() {
      if (JSON.parse(sessionStorage.getItem("from2"))) {
        const s = JSON.parse(sessionStorage.getItem("from2"));
        const ss = JSON.parse(sessionStorage.getItem("imgstaus"));
        this.ruleForm2 = s;
        this.imgstaus = ss;
        this.cha2 = 1;
        if (this.cha1 == "1" && this.cha2 == "1") {
          this.loading = false;
        }
      } else {
        this.selecttwo();
      }
    },
    //删除图片
    delimg(file, name) {
      console.log(file);
      console.log(name);
      this.ruleForm2["upimg" + name.name] = "";
    },
    //上传图片接口
    async upimg(file, name) {
      console.log(file);
      console.log(name);
      this.imgstaus["fileList" + name.name][0].status = "uploading";
      this.imgstaus["fileList" + name.name][0].message = "上传中...";
      console.log("原始图片" + file.file.size / 1024 + "KB");
      let form = new FormData();
      let imgFile;
      if (file.file.size / 1024 > 2048) {
        imgFile = await this.blobToBase64(file.file, file.file.name, name.name);
        console.log(imgFile);
        console.log("压缩之后图片" + imgFile.size / 1024 + "KB");
        form.append("file", imgFile);
      } else {
        form.append("file", file.file);
      }
      const res = await upimg(form);
      console.log(res);
      if (res.code == "200") {
        let ss = res;
        ss.url = process.env.VUE_APP_FILE_UPLOAD_URL + ss.url;
        this.ruleForm2["upimg" + name.name] = res.fileName;
        // this.imgstaus["fileList" + name.name].push(ss);
        this.imgstaus["fileList" + name.name][0].status = "success";
        this.imgstaus["fileList" + name.name][0].content = "";
        this.imgstaus["fileList" + name.name][0].url = ss.url;
      } else {
        // this.imgstaus["upimg" + s] = false;
        // this.imgstaus["fileList" + s] = [];
        this.imgstaus["fileList" + name.name][0].status = "failed";
        this.imgstaus["fileList" + name.name][0].message = "上传失败";
        // this.imgstaus["fileList" + name.name][0] = [];
        console.log(this.imgstaus["fileList" + name.name][0]);
        this.$toast("上传失败," + res.msg);
      }
    },
    //file转base64
    async blobToBase64(blob, s, name) {
      const self = await this; // 绑定this
      const reader = await new FileReader(); // 实例化一个reader文件
      await reader.readAsDataURL(blob); // 添加二进制文件
      return new Promise(function (resolve, reject) {
        reader.onload = async function (event) {
          const base64 = await event.target.result; // 获取到它的base64文件
          const scale = 0.92; // 设置缩放比例 （0-1）
          let file = await self.compressImg(base64, scale, s, name);
          resolve(file);
        };
      });
    },
    //压缩
    async compressImg(base64, scale, s, name) {
      console.log(`开始缩放，scale=${scale}`);
      // 处理缩放，转换格式
      // 用canvas来压缩
      const img = new Image();
      const self = this;
      img.src = base64;
      return new Promise(function (resolve, reject) {
        img.onload = async function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.setAttribute("width", this.width);
          canvas.setAttribute("height", this.height);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          // 转成base64 文件
          base64 = canvas.toDataURL("image/jpeg", 0.5);
          // self.imgstaus["fileList" + name][0].content = base64;
          const arr = base64.split(",");
          const mime = arr[0].match(/:(.*?);/)[1];
          const bytes = atob(arr[1]);
          const bytesLength = bytes.length;
          const u8arr = new Uint8Array(bytesLength);
          for (let i = 0; i < bytes.length; i++) {
            u8arr[i] = bytes.charCodeAt(i);
          }
          const file = await new File([u8arr], s, { type: mime });
          resolve(file);
        };
      });
    },
    //判断上传格式和大小
    beforeUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 < 2048;
      console.log(file.size / 1024 + "KB");
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2M!");
      }
      return isLt2M;
    },
    back() {
      this.$router.push({
        path: "/p-register",
        query: {
          // backId:
          //   this.backId === undefined
          //     ? this.ruleForm2.checkInfoId
          //     : this.backId,
        },
      });
    },
    next() {
      const a = JSON.parse(sessionStorage.getItem("twoid"));
      if (
        (a === "undefined" || a == null || a === "") &&
        this.firstget == "0"
      ) {
        this.selecttwo1();
      } else {
        if (this.tjpan == 0) {
          this.submit();
        }
      }
    },
    //保存
    async submit() {
      this.loading = true;
      this.tjpan = 1;
      const res = await savetwo({
        id: JSON.parse(sessionStorage.getItem("twoid")), //报名id
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
        guardianOneIdcardFrontPath: this.ruleForm2.upimg1, //监护人（一）证件正面
        guardianOneIdcardBackPath: this.ruleForm2.upimg2, //监护人（一）证件反面
        guardianTwoIdcardFrontPath: this.ruleForm2.upimg3, //监护人（二）证件正面
        guardianTwoIdcardBackPath: this.ruleForm2.upimg4, //监护人（二）证件反面
        marriageCertificatePath: this.ruleForm2.upimg5, //结婚证
        householdPagePath: this.ruleForm2.upimg6, //户主页
        fatherPagePath: this.ruleForm2.upimg16, //父亲户口页
        motherPagePath: this.ruleForm2.upimg17, //母亲户口页
        // divorceCertificatePath: this.ruleForm2.upimg7, //离婚证
        // divorceAgreementPath: this.ruleForm2.upimg8, //离婚协议
        studentPagePath: this.ruleForm2.upimg9, //学生户口页
        birthCertificatePath: this.ruleForm2.upimg10, //出生证明
        residencePermitPath: this.ruleForm2.upimg11, //居住证照片
        zfmhkyPath: this.ruleForm2.upimg18, //（外）祖父母户口页
        otherProofPath: this.ruleForm2.upimg19, //其他证明
        xsszhkbsyPath: this.ruleForm2.upimg20, //学生所在户口本首页
        // upimg12: this.ruleForm2.upimg12, //特殊优抚 其他 证明信
        // upidemolitionAgreementPathmg13: this.ruleForm2.upimg13, //拆迁协议
        // upimg14: this.ruleForm2.upimg14, //特殊优抚 哥哥或姐姐出生证明
      });
      console.log(res);
      this.loading = false;
      this.tjpan = 0;
      if (res.code == "200") {
        this.$toast("保存成功");
        sessionStorage.setItem("from2", JSON.stringify(this.ruleForm2));
        sessionStorage.setItem("imgstaus", JSON.stringify(this.imgstaus));
        sessionStorage.setItem("twoid", JSON.stringify(res.data.id));
        this.$router.push({
          path: "/property",
          // query: { typeId: this.typeId, householdId: this.householdId },
        });
        // if (this.ruleForm1.isfc == "1") {
        //   this.$router.push({
        //     path: "/school",
        //     // query: { typeId: this.typeId, householdId: this.householdId },
        //   });
        // } else {
        //   this.$router.push({
        //     path: "/property",
        //     // query: { typeId: this.typeId, householdId: this.householdId },
        //   });
        // }
      } else {
        this.$toast("提交失败," + res.msg);
      }
    },
    //查询返显
    async selecttwo() {
      this.$toast.loading();
      const res = await selecttwo({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      this.cha2 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm2.upimg1 = s.guardianOneIdcardFrontPath; //监护人1正面
        this.ruleForm2.upimg2 = s.guardianOneIdcardBackPath; //监护人1反面
        this.ruleForm2.upimg3 = s.guardianTwoIdcardFrontPath; //监护人2正面
        this.ruleForm2.upimg4 = s.guardianTwoIdcardBackPath; //监护人2反面
        this.ruleForm2.upimg5 = s.marriageCertificatePath; //结婚证
        this.ruleForm2.upimg6 = s.householdPagePath; //户主页
        this.ruleForm2.upimg7 = s.divorceCertificatePath; //离婚证
        this.ruleForm2.upimg8 = s.divorceAgreementPath; //离婚协议
        this.ruleForm2.upimg9 = s.studentPagePath; //学生户口页
        this.ruleForm2.upimg10 = s.birthCertificatePath; //出生证明
        this.ruleForm2.upimg11 = s.residencePermitPath; //居住证照片
        // this.ruleForm2.upimg12 = s.name; //特殊优抚 其他 证明信
        // this.ruleForm2.upimg13 = s.demolitionAgreementPath; //拆迁证明
        // this.ruleForm2.upimg14 = s.name; //特殊优抚 哥哥或姐姐出生证明
        // this.ruleForm2.upimg15 = s.name; //监护人户口页
        this.ruleForm2.upimg16 = s.fatherPagePath; //父亲户口页
        this.ruleForm2.upimg17 = s.motherPagePath; //母亲户口页
        this.ruleForm2.upimg18 = s.zfmhkyPath; //（外）祖父母户口页
        this.ruleForm2.upimg19 = s.otherProofPath; //其他证明
        this.ruleForm2.upimg20 = s.xsszhkbsyPath; //学生所在户口本首页

        for (let i = 1; i < 21; i++) {
          this.imgstaus["upimg" + i] =
            this.ruleForm2["upimg" + i] != "" &&
            this.ruleForm2["upimg" + i] != undefined &&
            this.ruleForm2["upimg" + i] != null
              ? true
              : false;
          if (
            this.ruleForm2["upimg" + i] != "" &&
            this.ruleForm2["upimg" + i] != undefined &&
            this.ruleForm2["upimg" + i] != null
          ) {
            this.imgstaus["fileList" + i].push({
              url:
                process.env.VUE_APP_FILE_UPLOAD_URL +
                this.ruleForm2["upimg" + i],
              s: i,
            });
          }
        }

        sessionStorage.setItem("imgstaus", JSON.stringify(this.imgstaus));
        sessionStorage.setItem("from2", JSON.stringify(this.ruleForm2));
        sessionStorage.setItem("twoid", JSON.stringify(res.data.id));
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显1
    async selecttwo1() {
      this.$toast.loading();
      const res = await selecttwo({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      if (res.code == "200") {
        if (res.data) {
          sessionStorage.setItem("twoid", JSON.stringify(res.data.id));
          this.next();
        } else {
          this.firstget = "1";
          this.next();
        }
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显one
    async selectone() {
      const res = await selectone({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.cha1 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm1.name = s.studentName; //学生姓名
        this.ruleForm1.idCard = s.studentIdcard; //学生身份证号
        this.ruleForm1.gender = s.studentGender; //学生性别
        this.ruleForm1.nation = s.studentNation; //学生民族
        this.ruleForm1.birthDate = s.studentBirthday; //学生出生日期
        this.ruleForm1.yuanyin = s.xsylhjrgx; //学生与落户籍人关系
        this.ruleForm1.yuanyin1 = s.xsylhjrgxyy; //学生与落户籍人关系原因
        this.ruleForm1.istwins = s.isTwins; //是否是双胞胎（1：是，2：否）
        this.ruleForm1.tname = s.twinName; //双胞胎姓名
        this.ruleForm1.tidno = s.twinIdcard; //双胞胎身份证号
        this.ruleForm1.isonehk = s.xshfmsfzyghkb; //学生和父母是否在一个户口本（1：是，2：否）
        // this.ruleForm1.yuanyin = s.xshfmbzyghkbyy; //原因
        this.ruleForm1.ishjbd = s.xshjsfzbd; //学生户籍是否在本地（1：是，2：否）
        this.ruleForm1.isfc = s.hasHouse; //有无房产
        this.ruleForm1.isjzz = s.hasResidencePermit; //有无居住证
        this.ruleForm1.yesdate = s.residencePermitLifespan.split(","); //居住证有效期
        this.ruleForm1.stardate =
          this.ruleForm1.yesdate.length > 0 ? this.ruleForm1.yesdate[0] : ""; //居住证有效期开始时间
        this.ruleForm1.enddate =
          this.ruleForm1.yesdate.length > 1 ? this.ruleForm1.yesdate[1] : ""; //居住证有效期结束时间
        this.ruleForm1.jzaddress = s.residencePermitAddress; //居住证上现居住地址
        this.ruleForm1.hjpcs = s.studentDomicilePolice; //学生户籍地派出所
        this.ruleForm1.hjszd = s.domicileAddress; //户籍详细地址
        this.ruleForm1.detailedAddress = s.nowAddress; //现居住详细地址
        this.ruleForm1.special = s.tsyf; //特殊优抚
        this.ruleForm1.ggyuanyin = s.tsyfReason; //特殊优抚说明原因
        this.ruleForm1.geigeiname = s.ggjjname; //哥哥/姐姐姓名
        this.ruleForm1.geigeiidno = s.ggjjidcard; //哥哥/姐姐身份证号
        this.ruleForm1.ggschool = s.ggjjschool; //哥哥/姐姐学校
        this.ruleForm1.ggclass = s.ggjjgrade; //哥哥/姐姐年级
        this.ruleForm1.isgghkb = s.sfyggjjzyghkb; //是否和哥哥姐姐在同一个户口本
        this.ruleForm1.firstGuardianName = s.guardionOneName; //监护人（一）姓名
        this.ruleForm1.firstGuardianRelationship = s.guardionOneRelation; //监护人（一）关系
        this.ruleForm1.firstGuardianIdcardType = s.guardionOneDocumentType; //监护人（一）证件类型
        this.ruleForm1.firstGuardianIdcard = s.guardionOneDocumentNumber; //监护人（一）证件号码
        this.ruleForm1.firstGuardianPhone = s.guardionOneDocumentPhone; //监护人（一）联系电话
        this.ruleForm1.secondGuardianName = s.guardionTwoName; //监护人（二）姓名
        this.ruleForm1.secondGuardianRelationship = s.guardionTwoRelation; //监护人（二）关系
        this.ruleForm1.secondGuardianIdcardType = s.guardionTwoDocumentType; //监护人（二）证件类型
        this.ruleForm1.secondGuardianIdcard = s.guardionTwoDocumentNumber; //监护人（二）证件号码
        this.ruleForm1.secondGuardianPhone = s.guardionTwoDocumentPhone; //监护人（二）联系电话
        // sessionStorage.setItem("from1", JSON.stringify(this.ruleForm1));
        // sessionStorage.setItem("oneid", JSON.stringify(res.data.id));
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    toCreate() {
      this.$router.push("create");
    },
    getParams() {
      this.ruleForm2.checkInfoId =
        this.$route.query.typeId === undefined
          ? this.$route.query.backId
          : this.$route.query.typeId;
      this.ruleForm2.householdId = this.$route.query.householdId;
      this.backId = this.$route.query.backId;
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  width: 100%;
}
.navigation {
  width: 90%;
  height: 1.5rem;
  margin: 1.5rem auto;
  margin-bottom: 2.2rem;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.navigation p {
  width: 1.2rem;
  height: 0.04rem;
  background: #b2dcd8;
  position: relative;
  border: 0.04rem dashed #fff;
  top: -0.2rem;
}
.navigation .dddiv {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2.4rem;
  border: 0.04rem dashed #0f9386;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigation .dd {
  width: 1.2rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  background: #b2dcd8;
  border-radius: 0.6rem;
  font-size: 0.52rem;
  color: #fff;
  border: 0.04rem solid #fff;
  position: relative;
}
.navigation .dd span {
  display: block;
  width: 2rem;
  height: auto;
  position: absolute;
  top: 1.5rem;
  left: -0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #ccc;
  letter-spacing: 0.006rem;
}
.navigation .li_special {
  background: #0f9386;
}
.navigation .li_special span {
  color: #000;
}
.btn {
  width: 4.8rem;
  background: #0f9386;
  color: #fff;
  margin-left: 1rem;
  border-radius: 0.2rem;
}
.van-cell {
  display: flex;
  flex-direction: column;
}
/deep/.van-field__label {
  width: 8rem;
}
.tupian {
  display: flex;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 3rem;
    height: 3rem;
    margin-right: 0.3rem;
    // margin-top: 1rem;.
  }
  span {
    margin-top: 0.5rem;
    font-size: 0.48rem;
    color: red;
  }
}
.bgdiv {
  height: 0.4rem;
}
/deep/.van-uploader__preview-image {
  width: 3.2rem;
  height: 3.2rem;
}
/deep/.van-uploader__upload {
  width: 3.2rem;
  height: 3.2rem;
}
/deep/.van-field__control--custom {
  align-items: flex-start;
  padding-top: 0.5rem;
}
</style>